"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _button = _interopRequireDefault(require("../../styles/button"));
var _VisuallyHidden = _interopRequireDefault(require("../VisuallyHidden"));
var _excluded = ["loading", "variant", "sizeMediaMediumUp"],
  _excluded2 = ["text", "children", "disabled", "loading", "variant", "sizeMediaMediumUp"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
// filtering styling props from being rendered as HTML attributes
// https://github.com/styled-components/styled-components/issues/439
var StyledButton = (0, _styledComponents["default"])(function (_ref) {
  var loading = _ref.loading,
    variant = _ref.variant,
    sizeMediaMediumUp = _ref.sizeMediaMediumUp,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("button", rest);
}).withConfig({
  displayName: "Button__StyledButton",
  componentId: "sc-9sjskx-0"
})(["", ""], _button["default"]);
var Button = function Button(_ref2) {
  var text = _ref2.text,
    children = _ref2.children,
    _ref2$disabled = _ref2.disabled,
    disabled = _ref2$disabled === void 0 ? false : _ref2$disabled,
    _ref2$loading = _ref2.loading,
    loading = _ref2$loading === void 0 ? false : _ref2$loading,
    _ref2$variant = _ref2.variant,
    variant = _ref2$variant === void 0 ? 'primary' : _ref2$variant,
    _ref2$sizeMediaMedium = _ref2.sizeMediaMediumUp,
    sizeMediaMediumUp = _ref2$sizeMediaMedium === void 0 ? 'auto' : _ref2$sizeMediaMedium,
    props = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, loading && /*#__PURE__*/_react["default"].createElement(_VisuallyHidden["default"], {
    "aria-live": "assertive"
  }, "loading"), /*#__PURE__*/_react["default"].createElement(StyledButton, _extends({}, props, {
    disabled: loading || disabled,
    variant: disabled ? 'disabled' : variant,
    loading: loading,
    sizeMediaMediumUp: sizeMediaMediumUp
  }), text || children));
};
Button.propTypes = {
  text: _propTypes["default"].string,
  children: _propTypes["default"].node
};
var _default = exports["default"] = Button;